import { useCallback } from 'react';

import { useInitializeOrderOnDemand } from '@api';
import { IOrderState } from '@model';

import { ILastOrder } from '../../../model';

export const useCheckoutInitOrder = () => {
  const { request: initializeOrder } = useInitializeOrderOnDemand();

  const request = useCallback(
    async (data: ILastOrder): Promise<IOrderState | null> =>
      await initializeOrder({
        deliveryInfo: data.deliveryInfo,
        deliveryAddress: data.deliveryAddress,
        invoiceAddress: data.invoiceAddress,
        paymentInfo: {
          paymentType: data.paymentInfo.paymentType,
          paymentPrice: data.paymentInfo.paymentPrice,
          paymentName: data.paymentInfo.paymentName,
          paymentGroups: data.paymentInfo.paymentGroups,
        },
        sameDeliveryAndInvoice: data.sameDeliveryAndInvoice,
      }),
    [initializeOrder],
  );

  return { request };
};
